// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ReVAMPOutOfUse/viewOutOfUse/ViewOutOfUse.css
// module id = 2281
// module chunks = 0